export default __webpack_public_path__ + "static/media/coin.f8f002c2.svg";